// Clasificacion Plantilla/Seguridad/Eventual de los reportes IPEJAL (Reporte de Conciliacion en
// Carga Externa de Descuentos y Generador de Polizas de Carga Externa). Se basa en el Tipo de
// Empleado Presupuestal de la plaza (Plazas > Sueldo), congelado por el backend al momento de la
// carga externa o del calculo de la nomina (`tipo_de_empleado_presupuestal_clave`).
// Los tipos que no estan aqui (Honorarios, Becarios) o un registro sin tipo no caen en ninguna
// columna: solo suman en IPEJAL y se reflejan en DIFERENCIA.
export const GRUPO_POR_TIPO_DE_EMPLEADO_PRESUPUESTAL = {
  G: 'plantilla', // Gabinete
  P: 'plantilla', // Permanente (Plantilla)
  C: 'seguridad', // Permanente - Comisaria
  E: 'eventual', // Eventual
};

export const clasificarGrupoIPEJAL = (item) => {
  const clave = (item?.tipo_de_empleado_presupuestal_clave || '').trim().toUpperCase();
  return GRUPO_POR_TIPO_DE_EMPLEADO_PRESUPUESTAL[clave] || null;
};

export default clasificarGrupoIPEJAL;
